<!--下单-->
<template>
    <div>
        <van-cell-group>
            <van-field
                    v-model="formData.buyer.name"
                    label="用户名"
                    placeholder="请输入姓名"
                    input-align="right"
            />

            <van-field
                    v-model="formData.buyer.phone"
                    type="text"
                    label="手机"
                    placeholder="请输入手机"
                    input-align="right"
            />
            <van-field
                    v-model="formData.buyer.note"
                    label="留言"
                    placeholder="您还有其他什么要求..."
            />
        </van-cell-group>
        <div class="border-top" v-for="(order, index) in order_list">
            <div class="row-title" v-if="order.open_seller_fenxiao==2">
                <div class="title-left">
                    <img class="row-title-img" :src="order.business_pic_url" alt="">
                    {{order.business_name}}
                </div>
                <div @click="couponSelect(index)" class="title-right" v-if="order.coupon_list.length > 0">
                选择优惠券({{order.coupon_list.length}})
            </div>
            </div>

            <div class="flex-between row-between" v-for="(goods, index) in order.goods_items">
                <div class="between-left flex-start">
                    <img class="between-left-img" :src="goods.pic_url" alt="">
                    <div class="goods-box">
                        <div class="between-left-title">{{goods.title}}</div>
                        <div class="between-left-detail gray-light">{{goods.sku.sku_formart}}</div>
                        <div class="between-left-price">¥{{goods.price/100</div>
                    </div>
                </div>
                <div class="between-right">
                    <div class="between-right-num gray-light"><span>数量</span> {{goods.count}}</div>
                </div>
            </div>
            <div class="flex-between row-list border-bottom">
                <div>商品金额</div>
                <div class="row-right flex-end">
                    ¥{{order.goods_price/100
                </div>
            </div>
            <div class="flex-between row-list border-bottom">
                <div>优惠</div>
                <div class="row-right flex-end">
                    <span>¥{{order.discount_price/100</span>
                </div>
            </div>
        </div>

        <div style="height: 44px;"></div>
        <div class="footer flex-between">
            <div class="footer-left flex-start">
                <span class="gray">总计</span>¥{{pay_price/100
            </div>
            <div class="footer-right" @click="submit" v-if="!submitLoading">去支付</div>

            <div class="footer-right" v-else>提交中...</div>
        </div>
        <PayDialog :show="payDialogShow" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
        <CouponPicker :show="couponPickerShow" :list="currentCouponList" @onChange="changeCoupon"
                      :business_id="currentBusinessId" :index="currentBusinessIndex"/>

    </div>
</template>
<style scoped>
    .goods-box {
        max-width: 230px;
    }

    .van-hairline--top-bottom::after {
        border: none;
    }

    .van-cell {
        padding: 5px 0.31rem;
    }

    .icon-right-tip {
        width: 16px;
        height: 16px;
    }

    .address {
        padding: 0.3rem 0.2rem 0.3rem 0.36rem;
        position: relative;
    }

    .border-top {
        border-top: 0.1rem solid #EFEFEF;
    }

    .border-bottom {
        border-bottom: 1px solid #EFEFEF;
    }

    .address-img {
        width: 0.33rem;
        height: 0.42rem;
        margin-right: 0.2rem;
    }

    .address-detail {
        font-size: 12px;
        color: #333333;
    }

    .address-back {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: url('../../../assets/newImg/bg-address-line.png');
        background-size: 1.7rem 2px;
    }

    .row {
        padding: 0.2rem 0.31rem;
        color: #333333;
    }

    .row-title {
        padding: 0.2rem 0.33rem;
        display: flex;
        /*justify-content: flex-start;*/
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #EFEFEF;
    }

    .row-title-img {
        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.2rem;
    }

    .title-left {
        display: flex;
        align-items: center;
    }

    .title-right {
        background: #FD2840;
        color: #fff;
        padding: 4px;
        border-radius: 4px;
    }

    .between-left-img {
        width: 1.1rem;
        height: 1.1rem;
        margin-left: 0.16rem;
        margin-right: 0.2rem;
    }

    .row-between {
        padding: 0.2rem 0;
        /*margin: 0 0.15rem;*/
        margin: 0 0.31rem 0 0.15rem;
        border-bottom: 1px solid #EFEFEF;
    }

    .row-between:last-of-type {
        border: none;
    }

    .between-left-detail {
        font-size: 11px;
        margin: 0.1rem 0;
    }

    .between-left-price {
        color: #F05656;
    }

    .between-right-num span {
        font-size: 12px;
    }

    .between-right {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        height: 1.2rem;
    }

    .row-list {
        margin: 0 0.31rem;
        padding: 0.2rem 0;
    }

    .row-list span {
        color: #F05656;
    }

    .leave {
        margin-bottom: 0.2rem;
    }

    .footer {
        position: fixed;
        height: 44px;
        left: 0;
        bottom: 0;
        width: 100%;
        background: #fff;
    }

    .footer-left {
        color: #111111;
        font-size: 17px;
        padding-left: 0.33rem;
        width: 4.39rem;
        border-top: 1px solid #EFEFEF;
        height: 44px;
    }

    .footer-left span {
        font-size: 12px;
        margin-right: 0.2rem;
    }

    .footer-right {
        width: 3.11rem;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        color: #fff;
        background: rgba(253, 40, 64, 1);
    }
</style>

<script>
    import LoginDialog from '@/components/LoginDialog.vue';
    import AddressPicker from '@/components/AddressPicker.vue';
    import PayDialog from '@/components/PayDialog.vue';
    import CouponPicker from '@/components/CouponPicker.vue';

    import {
        Field, Notify
    } from 'vant';

    export default {
        name: 'OrderCheck',
        components: {
            [Field.name]: Field,
            AddressPicker,
            PayDialog,
            CouponPicker,
            Notify,
            LoginDialog
        },
        data: function () {
            return {
                loginShow: false,
                addressPickerShow: false,
                payDialogShow: false,
                couponPickerShow: false,
                currentCouponList: [],
                currentBusinessIndex: 0,
                currentBusinessId: 0,
                message: "",

                formData: {
                    needLoadingIndicator: true,
                    buyer: {
                        name: '',
                        phone: '',
                        note: ''
                    },
                    goods_items: [],
                    coupon_used: {},
                },


                address: {},
                pay_price: 0,
                orderIds: [],

                warnings: [],
                submitDisabled: true,
                submitLoading: false,
                order_list: []

            }
        },

        filter: {},
        mounted() {
            document.title = '提交订单';
            let that = this;
            that.getOrderLoad();
        },
        destroyed() {
        },
        methods: {
            // 获取订单详细信息
            getOrderLoad() {
                let that = this;
                that.formData.goods_items = JSON.parse(localStorage.getItem('order_check_goods_items'));

                this.$api.post('/api/shopOrder/formdata', that.formData, (res) => {

                    that.order_list = res.data.order_list;
                    that.pay_price = res.data.pay_price;

                    that.formData.buyer = res.data.buyer;

                    res.data.order_list.map(order => {
                        order.note_id = order.business_id
                    })

                    // 判断有没有warning
                    if (res.data.warnings.length > 0) {
                        Notify({
                            message: res.data.warnings[0],
                            duration: 2000,
                            background: '#FF4444'
                        });
                        that.warnings = res.data.warnings
                        that.submitDisabled = true;
                    } else {
                        that.submitDisabled = false;
                    }
                }, (res) => {
                    if (res.code == 401 || res.code == 402) {
                        that.loginShow = true
                    } else {
                        that.warnings = res.msg

                        Notify({
                            message: res.msg,
                            duration: 5000,
                            background: '#FF4444'
                        });
                    }
                })
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                let that = this;
                that.loginShow = false;
                that.getOrderLoad()
            },

            loginCancel() {
                console.log('-------取消登录--------');
            },


            // 添加留言
            noteChange(order_id, event) {
                /* let that = this;
                 that.formData.notes = {order_id : event.currentTarget.value}

                 console.log(that.formData)*/
            },

            changeAddress(address) {
                let that = this;
                console.log('更换地址', address);
                that.addressPickerShow = false;

                that.formData.address_id = address.address_id;
                that.getOrderLoad()
            },
            closeAddress() {
                let that = this;
                console.log('closeAddress');
                that.addressPickerShow = false;
            },
            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');


                this.$router.replace({
                    path: '/orderlist'
                })
            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
                that.payDialogShow = false;
                this.$router.replace({
                    path: '/orderlist'
                })
            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;
                this.$router.replace({
                    path: '/orderlist'
                })
            },

            couponSelect(index) {
                let that = this;

                console.log(that.order_list[index])
                /*that.currentCouponList = that.order_list[index].coupon_list;
                that.currentBusinessId = that.order_list[index].business_id;*/
                that.currentCouponList = that.order_list[index].coupon_list;
                that.currentBusinessId = that.order_list[index].business_id;
                that.currentBusinessIndex = index;
                console.log('弹出优惠券选择器');
                that.couponPickerShow = true;
            },

            changeCoupon(data) {
                let that = this;
                console.log('优惠券变化', data);
                that.formData.coupon_used[data.business_id] = data.list

                that.couponPickerShow = false;
                that.couponDiscountCompute(data.index, data.list)
            },

            // 提交订单
            submit() {
                let that = this;
                if (that.submitLoading) {
                    return false;
                }
                if (that.submitDisabled) {

                    console.log('--warnings--', that.warnings)
                    Notify({
                        message: that.warnings,
                        duration: 2000,
                        background: '#FF4444'
                    });
                    return false;
                }
                that.submitLoading = true;

                console.log(that.formData)

                this.$api.post('/api/shopOrder/orderAdd', that.formData, res => {
                    console.log(res)
                    that.orderIds = res.data.ids;
                    that.payDialogShow = true;
                    // this.selectComponent('#payDialog').payDialogShow(ids);
                }, res => {

                    that.submitLoading = false;

                    Notify({
                        message: res.msg,
                        duration: 2000,
                        background: '#FF4444'
                    });
                });
            },

            // 判断优惠券和订单价格
            couponDiscountCompute(index, list) {
                let that = this;
                let discountPrice = 0;
                list.map(item => {
                    discountPrice += parseFloat(item.price)
                });
                let orderPrice = parseFloat(that.order_list[index].goods_price) + parseFloat(that.order_list[index].express_price);
                if (discountPrice > orderPrice) {
                    //优惠金额不能大于订单金额
                    discountPrice = orderPrice;
                }

                // console.log(discountPrice,orderPrice)
                // 更改选择订单的优惠金额
                that.order_list[index].discount_price = discountPrice;
                that.payPriceCompute();
            },

            // 使用优惠券后的支付总金额
            payPriceCompute() {
                let that = this;
                let payPrice = 0;
                that.order_list.map(order => {
                    let orderPayPrice = 0;
                    orderPayPrice = parseFloat(order.goods_price) + parseFloat(order.express_price) - parseFloat(order.discount_price);
                    payPrice += orderPayPrice;
                });

                // console.log(payPrice)
                that.pay_price = payPrice;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// ShopOrderCheck.vue?63f75a16